import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { DefaultTriggerButton, DefaultTriggerButtonProps } from '../../DefaultTriggerButton/DefaultTriggerButton';
import { BetaBadge } from '../../../components/BetaBadge/BetaBadge';
import { messages } from '../../../i18n';
import { SideMenuHeader } from '../../../components/SideMenuHeader/SideMenuHeader';
import { ApplicationSvgIcon } from '../ApplicationSvgIcon/ApplicationSvgIcon';
import { MultiApplicationsInlineButtonWrapper } from './ApplicationsDropdownInlineTrigger.style';
import { useSelectedApplicationData } from './ApplicationsDropdownInlineTrigger';

export const MultiApplicationsInlineButton = forwardRef<HTMLButtonElement, Partial<DefaultTriggerButtonProps>>((props, ref) => {
  const { formatMessage } = useIntl();
  const applicationData = useSelectedApplicationData();

  return applicationData ? (
    <>
      <SideMenuHeader rightSlot={applicationData.isBeta && <BetaBadge />}>{formatMessage(messages.appsMenuHeader)}</SideMenuHeader>
      <MultiApplicationsInlineButtonWrapper>
        <DefaultTriggerButton
          ref={ref}
          leftSlot={<ApplicationSvgIcon size="sm" svg={applicationData.iconActive} />}
          selected
          analyticsMessage="products menu"
          {...props}
        >
          {formatMessage(messages[applicationData.name])}
        </DefaultTriggerButton>
      </MultiApplicationsInlineButtonWrapper>
    </>
  ) : null;
});
